export default __webpack_public_path__ + "static/linea3-preview-2-mb-arg-561273908add07afa1a06b03eacc9d71.png";